import { render, staticRenderFns } from "./phoneInputPopUpInput.vue?vue&type=template&id=4a27f6e2"
import script from "./phoneInputPopUpInput.vue?vue&type=script&lang=js"
export * from "./phoneInputPopUpInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports